import { useCallback, useState } from 'react';

export function useScreenshotModal() {
  const [visible, setVisible] = useState(false);
  const [src, setSrc] = useState(null);

  const openModal = useCallback((screenshotSrc, e) => {
    if (e?.preventDefault) e.preventDefault();
    e.stopPropagation();
    setSrc(screenshotSrc);
    setVisible(true);
  }, []);

  const closeModal = useCallback(() => {
    setVisible(false);
    setSrc(null);
  }, []);

  return {
    visible,
    src,
    openModal,
    closeModal,
  };
}
